import { trackingService, ActivityType } from '../../../services/analytics/TrackingService';

/**
 * Main tracking hook - provides all tracking functions in one convenient hook
 * 
 * @example
 * const { trackPageView, trackProductView, trackCartAdd } = useTracking();
 * 
 * // Track when needed:
 * await trackPageView('Shop', '/shop');
 * await trackProductView(product.id, { name: product.name });
 */
export const useTracking = () => {
    // Return all tracking functions
    return {
        // Manual page tracking
        trackPageView: async (screen: string, path?: string) => {
            await trackingService.trackPageView(screen, path);
        },

        // Product tracking
        trackProductView: async (productId: string, productData?: Record<string, any>) => {
            await trackingService.trackProductView(productId, productData);
        },

        // Cart tracking
        trackCartAdd: async (productId: string, quantity: number, productData?: Record<string, any>) => {
            await trackingService.trackCartAdd(productId, quantity, productData);
        },

        // Checkout tracking
        trackCheckoutStart: async (orderData?: Record<string, any>) => {
            await trackingService.trackCheckoutStart(orderData);
        },

        trackCheckoutComplete: async (orderId: string, orderData?: Record<string, any>) => {
            await trackingService.trackCheckoutComplete(orderId, orderData);
        },

        // Custom activity tracking
        trackActivity: async (
            activityType: ActivityType,
            screen?: string,
            activityData?: Record<string, any>
        ) => {
            await trackingService.trackActivity({
                activityType,
                screenName: screen,
                activityData
            });
        }
    };
};

// Export ActivityType for convenience
export { ActivityType };
